module.exports = __webpack_public_path__ + "img/download.0de6224d.svg";